import React from 'react';
import { render } from 'react-dom';

import Main from './Main';

window.DatoCmsPlugin.init((plugin) => {
  plugin.startAutoResizer();

  const container = document.createElement('div');
  const script = document.createElement('script');
  script.src = 'https://cdnjs.cloudflare.com/ajax/libs/tinymce/4.9.11/tinymce.min.js';
  script.id = 'tinyMce';
  document.body.appendChild(script);
  script.onload = () => {
    render(<Main plugin={plugin} />, container);
  };


  document.body.appendChild(container);

});
